import {CART_BUTTON_PRIMARY_CLASSES} from '@components/cart/CartButtonClasses';
import cn from 'clsx';
import {useState, useEffect} from 'react';
import {OutOfStockRouter} from '@components/preorders/out-of-stock-router';
import {ProductQuantitySelector} from '@components/product/desktop/QuantitySelector';
import {AddToCartButton} from '@components/product/global/AddToCart';
import {useProductProvider} from '@components/product/ProductProvider';

export const AddToCartDesktop = ({className, buttonText = 'Add to Cart'}) => {
  const {disableAddToCart, selectedVariant, id: productId} = useProductProvider();
  const [quantity, setQuantity] = useState(1);
  // console.log("[AddToCartDesktop] disableAddToCart:", disableAddToCart);

  useEffect(() => {
    // Reset quantity to 1 when productId changes
    setQuantity(1);
  }, [productId]);

  const currentlyInStock = selectedVariant?.currentlyInStock;

  const isDiscontinued = selectedVariant?.isDiscontinued === true;
  const tpaAndLvQtyCombinedRealOhTotal =
    (selectedVariant?.tpa_wh ?? 0) + (selectedVariant?.lv_wh ?? 0);
  const overRideStockWithRealQty = isDiscontinued && tpaAndLvQtyCombinedRealOhTotal > 0;

  if (!currentlyInStock && !overRideStockWithRealQty) {
    return <OutOfStockRouter product={selectedVariant} withQuantity={true} className={className} />;
  }

  const hideQuantityInputForTheseCategories = [
    'electronics-equalizers-and-crossovers',
    'amplifier-wiring-kits',
    'vehicle-specific-subwoofer-enclosures',
    'empty-subwoofer-enclosures',
    'loaded-subwoofer-enclosures',
    'complete-bass-package'
  ];
  const hideQuantityInput = hideQuantityInputForTheseCategories?.includes(
    selectedVariant?.category
  );

  return (
    <>
      <div className="mt-3 space-y-2 mb-3">
        <div className={cn('flex', className)}>
          {!hideQuantityInput && (
            <ProductQuantitySelector quantity={quantity} setQuantity={setQuantity} />
          )}

          <AddToCartButton
            selectedVariant={selectedVariant}
            className={CART_BUTTON_PRIMARY_CLASSES}
            quantity={quantity}
            addToCartButtonSource={'product-page-button'}
            disabled={disableAddToCart}>
            {buttonText}
          </AddToCartButton>
        </div>
      </div>
    </>
  );
};
